import Dialog from '@anm/components/modals/Dialog';
import Confirm from '@anm/components/notification/Confirm';
import { FC } from 'react';

export type OwnerAlertProps = {
  nextOwnerName: string;
  onClose: () => void;
  onMakeOwner: () => void;
};

const OwnerAlert: FC<OwnerAlertProps> = ({ nextOwnerName, onClose, onMakeOwner }) => (
  <Dialog onModalClose={onClose}>
    <Confirm
      title="One Owner Allowed"
      buttonLeft={{
        text: 'Make Owner',
        size: 'upper-medium',
        variant: 'red'
      }}
      buttonRight={{
        text: 'Cancel',
        size: 'upper-medium',
        variant: 'light-blue'
      }}
      onLeftButtonClick={onMakeOwner}
      onRightButtonClick={onClose}
    >
      {`There could be only one team owner! Please confirm you would like to make <b>${nextOwnerName}</b> new owner of the
      team and remove yourself from the ownership`}
    </Confirm>
  </Dialog>
);

export default OwnerAlert;
